import { render, staticRenderFns } from "./ModalDeleteUser.vue?vue&type=template&id=b60e4b64&scoped=true&"
import script from "./ModalDeleteUser.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteUser.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteUser.vue?vue&type=style&index=0&id=b60e4b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60e4b64",
  null
  
)

export default component.exports